import baustein from "baustein";
import template from "templates/modules/search_summary_bar";

/**
 *
 */
export default baustein.register("search-summary-bar", {
    template: template,
});
